import { useCallback } from 'react';

import { usePerformanceActions } from 'src/store';
import { useCipEvents } from 'src/services';
import { useErrorHandler } from 'src/hooks';
import { REVIEWS_CHANNELS, WEBSITE_CHANNELS } from 'src/data/performance';
import { ADD_RESOURCE_POPUP } from '../types';
import { usePopups } from '../services';

export const useAddResourcePopup = (showWebsitesOnly = false) => {
  const popups = usePopups();
  const performanceActions = usePerformanceActions();
  const cipEvents = useCipEvents();
  const handleError = useErrorHandler();

  return useCallback(
    (csvResource) => {
      return new Promise((resolve) => {
        popups.openPopup(ADD_RESOURCE_POPUP, {
          onClose: () => {
            resolve();
            popups.closePopup(ADD_RESOURCE_POPUP);
          },
          onSubmit: async ({ urls, channel, csvFile }) => {
            try {
              if (REVIEWS_CHANNELS.includes(channel)) {
                const result = await performanceActions.createReviewsAccount(urls, channel);
                cipEvents.trackConnectReviewsAccount(channel, urls);
                resolve({ channel, urls, id: result.id });
              } else if (WEBSITE_CHANNELS.includes(channel)) {
                const result = await performanceActions.createWebsiteAccount(urls, channel);
                cipEvents.trackConnectWebsiteAccounts(channel, urls);
                resolve({ channel, urls, id: result.id });
              } else {
                const result = await performanceActions.createResourceAccount(csvFile, channel);
                resolve({ channel: result.dataSource, ...result });
              }
              popups.closePopup(ADD_RESOURCE_POPUP);
            } catch (error) {
              performanceActions.setAccountExtractingCopies(channel, false);
              performanceActions.setCreatingResource(false);
              handleError(error);
            }
          },
          csvResource,
          showWebsitesOnly,
        });
      });
    },
    [popups, performanceActions, cipEvents, handleError, showWebsitesOnly]
  );
};
